export class UsuarioRequest {
  idUsuario: number | null;
  email: string;
  nomeUsuario: string;
  telefone: string;
  cpf: string;
  master: boolean;
  listaIdPerfil: number[];
}
